/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect, useState } from "react";
import { FlatList, Image, Text, View } from "react-native";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { useTranslation } from "react-i18next";
import styles from "./styles";
import {
  convertDate,
  copyWritings,
  maskedMoney,
  toast
} from "../../../../utils";
import {
  Card,
  Confirmation,
  Modal,
  Touchable,
  WrapContent,
  WrapList
} from "../../../../components";
import { IMAGES } from "../../../../configs";
import {
  deleteCashBill,
  getBillTrip,
  putSettle,
  putSubmitBill
} from "../../../../redux/actions";
import { Reducers } from "../../../../redux/types";

interface Props {
  id: string;
  isBillApproval?: boolean;
}

const Bill = ({ id, isBillApproval }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const { sprintf } = require("sprintf-js");
  const { expenseState, cashState, tripState } = useSelector(
    (state: Reducers) => ({
      expenseState: state.newExpenseTrip,
      cashState: state.cash,
      tripState: state.trip
    }),
    shallowEqual
  );

  const [modalDeleteBill, setModalDeleteBIll] = useState(false);
  const [modalSettle, setModalSettle] = useState(false);
  const [idBill, setIdBill] = useState("");

  const copTeks = {
    expense: copyWritings("expense"),
    cash_advance: copyWritings("cash_advance")
  };

  useEffect(() => {
    dispatch(getBillTrip(id));
  }, [dispatch, id]);

  const _totalItem = () => {
    if (expenseState.listBillTrip.length > 0) {
      return expenseState.listBillTrip.reduce((acc, current) => ({
        total: Number(acc.total) + Number(current.total)
      })).total;
    }
    return 0;
  };

  const _goToPreview = (link: string) => {
    window.open(`${link}`, "_blank");
  };

  const _deleteBill = () => {
    dispatch(
      deleteCashBill(idBill, (run, info) => {
        if (run) {
          setModalDeleteBIll(false);
          toast.success(t("cash.new.msg.toastDelete"));
          dispatch(getBillTrip(id));
        } else {
          toast.error(info);
        }
      })
    );
  };

  const _permissionCreate = () => {
    const invoice = expenseState.dataInvoiceTrip;
    const tripdata = tripState?.tripData;
    if (
      invoice?.total_paid >= invoice?.total &&
      [5, 8].includes(tripdata.status) &&
      tripdata?.users?.[0]?.expense &&
      tripdata?.users?.[0]?.expense_moderation === 1 &&
      !isBillApproval
    ) {
      return true;
    }
    return false;
  };

  const _permissionSettle = () => {
    const invoice = expenseState.dataInvoiceTrip;
    const tripdata = tripState.tripData;
    if (
      invoice?.total_paid >= invoice?.total &&
      [5, 8].includes(tripdata?.status) &&
      tripdata?.users?.[0]?.expense &&
      !tripdata?.users?.[0]?.expense_moderation &&
      !isBillApproval
    ) {
      return true;
    }
    return false;
  };

  const _permissionSubmit = () => {
    const invoice = expenseState.dataInvoiceTrip;
    const tripdata = tripState.tripData;
    if (
      invoice?.total_paid >= invoice?.total &&
      [5, 8].includes(tripdata?.status) &&
      tripdata?.users?.[0]?.expense &&
      tripdata?.users?.[0]?.expense_moderation === 1 &&
      !isBillApproval
    ) {
      return true;
    }
    return false;
  };

  const _settleBill = () => {
    const form = {
      invoice_id: "",
      trip_user_id: tripState.tripData && tripState.tripData.users[0].id,
      client_timezone: "Asia/Jakarta"
    };
    dispatch(
      putSettle(form, (run, info) => {
        if (run === true) {
          setModalSettle(false);
          toast.success("Data updated!");
          window.location.reload();
        } else {
          toast.error(info);
        }
      })
    );
  };

  const _submitBill = () => {
    const form = {
      invoice_id: "",
      trip_user_id: tripState.tripData && tripState.tripData.users[0].id,
      client_timezone: "Asia/Jakarta"
    };
    dispatch(
      putSubmitBill(form, (run, info) => {
        if (run === true) {
          setModalSettle(false);
          toast.success("Data updated!");
          window.location.reload();
        } else {
          toast.error(info);
        }
      })
    );
  };

  const _toFormBill = (item_id: string, file: any) => {
    history.push("/new-trip-bill", {
      trip_id: id,
      status: tripState.tripData && tripState.tripData.status,
      invoice_id:
        expenseState.dataInvoiceTrip !== null &&
        expenseState.dataInvoiceTrip.id,
      project_id:
        tripState.tripData?.project?.id || tripState.tripData?.project?.uuid,
      permissionCreate: _permissionCreate(),
      item_id,
      file
    });
  };

  return (
    <WrapContent isLoading={expenseState.isLoadingListReimburse}>
      <WrapList
        isEmpty={expenseState.listBillTrip.length === 0}
        emptyComponent={() =>
          _permissionCreate() || _permissionSettle() ? (
            <View
              style={[
                styles.wrapButtonEmpty,
                ((_permissionCreate() && _permissionSettle()) ||
                  (_permissionCreate() && _permissionSubmit())) && {
                  justifyContent: "space-between"
                }
              ]}
            >
              {_permissionSettle() && (
                <Card
                  onPress={() => setModalSettle(true)}
                  containerStyle={styles.button}
                  cardStyle={[styles.button2, styles.button3]}
                >
                  <Text style={[styles.buttonText, styles.buttonText2]}>
                    {t("cash.new.settled")}
                  </Text>
                </Card>
              )}
              {_permissionSubmit() && (
                <Card
                  onPress={() => setModalSettle(true)}
                  containerStyle={styles.button}
                  cardStyle={[styles.button2, styles.button3]}
                >
                  <Text style={[styles.buttonText, styles.buttonText2]}>
                    {t("cash.new.submit")}
                  </Text>
                </Card>
              )}
              {_permissionCreate() && (
                <Card
                  containerStyle={styles.button}
                  cardStyle={[styles.button2, styles.button3]}
                  onPress={() => _toFormBill("", "")}
                >
                  <Text style={[styles.buttonText, styles.buttonText2]}>
                    {sprintf(t("cash.new.addNew"), copTeks.expense)}
                  </Text>
                </Card>
              )}
            </View>
          ) : (
            <Text style={styles.emptyData}>{t("cash.new.noData")}</Text>
          )
        }
      >
        <View style={{ paddingHorizontal: 20 }}>
          <FlatList
            style={{
              marginTop: 11,
              paddingTop: 5
            }}
            data={expenseState.listBillTrip}
            keyExtractor={(item, index) => index.toString()}
            renderItem={({ item, index }) => (
              <Card
                cardStyle={styles.cardStyle}
                statusColor="#50b1b1"
                statusTextLight={t("cash.new.qty")}
                statusText={item ? ` ${item.quantity}` : "-"}
                statusDescLight="IDR "
                statusDesc={maskedMoney(item.total)}
                statusDescStyle={{ fontSize: 14 }}
                statusStyle={{ paddingVertical: 4, paddingHorizontal: 16 }}
                onPress={() => _toFormBill(item.id, item.file)}
                key={index}
              >
                <View style={styles.wrapContentCard}>
                  <View style={[styles.wrapCardText]}>
                    <Text style={styles.textLabel}>
                      {t("cash.new.subject")}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[styles.textLabel, styles.textValue, styles.bold]}
                    >
                      {item.title || "-"}
                    </Text>
                  </View>

                  <View style={[styles.wrapCardText]}>
                    <Text style={[styles.textLabel]}>{t("cash.new.date")}</Text>
                    <Text
                      style={[styles.textLabel, styles.textValue, styles.bold]}
                    >
                      <Text style={{ fontWeight: "normal" }}>
                        {`${convertDate(item.date, "ddd")} ` || "-"}
                      </Text>
                      {convertDate(item.date, "DD MMM YYYY") || ""}
                    </Text>
                  </View>

                  <View style={[styles.wrapCardText]}>
                    <Text style={styles.textLabel}>{t("cash.new.type")}</Text>
                    <Text
                      numberOfLines={1}
                      style={[styles.textLabel, styles.textValue]}
                    >
                      {item.category.title || "-"}
                    </Text>
                  </View>

                  <View style={[styles.wrapCardText]}>
                    <Text style={styles.textLabel}>
                      {t("activity.detail.desc")}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[styles.textLabel, styles.textValue]}
                    >
                      {item.description || "-"}
                    </Text>
                  </View>
                  {item.file && (
                    <Touchable
                      onPress={e => {
                        e.stopPropagation();
                        _goToPreview(item.file && JSON.parse(item.file).url);
                      }}
                    >
                      <View
                        style={[
                          styles.wrapBtnImage,
                          { right: 40 },
                          !_permissionCreate() && { right: 8 }
                        ]}
                      >
                        <Image
                          source={IMAGES.clipAttchment}
                          style={{ width: 18, height: 18 }}
                        />
                      </View>
                    </Touchable>
                  )}

                  {_permissionCreate() && (
                    <Touchable
                      onPress={e => {
                        e.stopPropagation();
                        setIdBill(item.id);
                        setModalDeleteBIll(true);
                      }}
                    >
                      <View style={styles.wrapBtnImage}>
                        <Image
                          source={IMAGES.trashBin}
                          style={{ width: 13, height: 16 }}
                        />
                      </View>
                    </Touchable>
                  )}
                </View>
              </Card>
            )}
          />
          <View
            style={[
              styles.wrapButtonAdd,
              ((_permissionCreate() && _permissionSettle()) ||
                (_permissionCreate() && _permissionSubmit())) && {
                justifyContent: "space-between"
              }
            ]}
          >
            {_permissionCreate() && (
              <Card
                containerStyle={styles.button}
                cardStyle={[styles.button2, styles.button3]}
                onPress={() => _toFormBill("", "")}
              >
                <Text style={[styles.buttonText, styles.buttonText2]}>
                  {sprintf(t("cash.new.addNew"), copTeks.expense)}
                </Text>
              </Card>
            )}
            {_permissionSubmit() && (
              <Card
                onPress={() => setModalSettle(true)}
                containerStyle={styles.button}
                cardStyle={[styles.button2, styles.button3]}
              >
                <Text style={[styles.buttonText, styles.buttonText2]}>
                  {t("cash.new.submit")}
                </Text>
              </Card>
            )}
            {_permissionSettle() && (
              <Card
                onPress={() => setModalSettle(true)}
                containerStyle={styles.button}
                cardStyle={[styles.button2, styles.button3]}
              >
                <Text style={[styles.buttonText, styles.buttonText2]}>
                  {t("cash.new.settled")}
                </Text>
              </Card>
            )}
          </View>
          <View style={styles.wrapTotal}>
            <Text style={styles.totalLabel}>
              {sprintf(t("cash.new.total"), copTeks.expense)}
            </Text>
            <Text style={styles.amountText}>
              <Text style={{ fontWeight: "normal" }}>IDR </Text>
              {maskedMoney(_totalItem())}
            </Text>
          </View>
        </View>
      </WrapList>
      <Modal isVisible={modalDeleteBill} backdropColor="rgba(255,255,255, 0.9)">
        <Confirmation
          headerTitle={sprintf(t("cash.new.deleteCop"), copTeks.expense)}
          description={t("cash.new.msg.deleteBill")}
          actionTitle={t("cash.new.delete")}
          cancelTitle={t("cash.new.cancel")}
          onCancel={() => setModalDeleteBIll(false)}
          isLoading={cashState.isLoadingDeletBill}
          onAction={_deleteBill}
        />
      </Modal>
      <Modal isVisible={modalSettle} backdropColor="rgba(255,255,255, 0.9)">
        <Confirmation
          headerTitle={
            _permissionSubmit()
              ? "SUBMIT CASH ADVANCE"
              : sprintf(t("cash.new.settleCA"), copTeks.cash_advance)
          }
          // eslint-disable-next-line max-len
          description={sprintf(
            t("cash.new.msg.settleMsg"),
            copTeks.expense,
            copTeks.expense,
            copTeks.cash_advance
          )}
          actionTitle={
            _permissionSubmit() ? "SUBMIT" : t("cash.new.settled").toUpperCase()
          }
          cancelTitle={t("cash.new.cancel")}
          onCancel={() => setModalSettle(false)}
          isLoading={
            _permissionSubmit()
              ? cashState.isLoadingSubmitBill
              : cashState.isLoadingDeletBill
          }
          onAction={_permissionSubmit() ? _submitBill : _settleBill}
        />
      </Modal>
    </WrapContent>
  );
};

export default Bill;
